import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import OtherWorkInsertModal from "../OtherWorkInsertModal";

import { getAllProject } from "../../../reducer/project/action";
import { getAllOtherWork, getAllOtherWorkByProfileId, getFilteredOtherWork } from "../../../reducer/otherWork/action";

function OtherWorkButton(props) {
  const { getAllOtherWork, getAllOtherWorkByProfileId, getFilteredOtherWork } = props;

  const [inserting, setInserting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllOtherWorkByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredOtherWork.length === 0 && !props.isFetching)
      getFilteredOtherWork(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredOtherWork(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredOtherWork]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllOtherWorkByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredOtherWork(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Các hoạt động khác
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <OtherWorkInsertModal inserting={inserting} setInserting={setInserting} />
    </>
  );
}

const mapStateToProps = (state) => ({
  // isFetching: select(state, 'projectReducer', 'isFetching'),
  // isFetchingAccepted: select(state, 'projectReducer', 'isFetchingAccepted'),

  profileDetail: select(state, "profileReducer", "detail"),
  listOtherWorkById: select(state, "otherWorkReducer", "listById"),
  listFilteredOtherWork: select(state, "otherWorkReducer", "listFiltered"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllOtherWorkByProfileId: (id) => dispatch(getAllOtherWorkByProfileId(id)),
  getFilteredOtherWork: (page, pageSize, payload) => dispatch(getFilteredOtherWork(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(OtherWorkButton));

